type NamedItem = {
    id?: number
    name?: string | null
}

type ShiftLike = {
    id?: number
    title?: string | null
    duty?: { name?: string | null } | null
    duty_name?: string | null
    start_time?: string | null
    end_time?: string | null
}

const collator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: 'base',
})

const compareText = (a?: string | null, b?: string | null) => {
    return collator.compare(a || '', b || '')
}

const compareId = (a?: number, b?: number) => {
    return (a ?? 0) - (b ?? 0)
}

export const compareByName = <T extends NamedItem>(a: T, b: T) => {
    return compareText(a.name, b.name) || compareId(a.id, b.id)
}

export const sortByName = <T extends NamedItem>(items: readonly T[] | undefined | null): T[] => {
    return [...(items ?? [])].sort(compareByName)
}

export const getShiftDisplayName = (shift: ShiftLike) => {
    return shift.title || shift.duty?.name || shift.duty_name || `Shift ${shift.id ?? ''}`.trim()
}

export const compareShifts = <T extends ShiftLike>(a: T, b: T) => {
    return compareText(getShiftDisplayName(a), getShiftDisplayName(b))
        || compareText(a.start_time, b.start_time)
        || compareText(a.end_time, b.end_time)
        || compareId(a.id, b.id)
}

export const sortShifts = <T extends ShiftLike>(items: readonly T[] | undefined | null): T[] => {
    return [...(items ?? [])].sort(compareShifts)
}
